import React from "react";
import styled from "styled-components";
import { SideNavContainer } from "storybook-components/Container";

const StyledSideNav = styled.div`
  display: flex;
  position: sticky;
  top: 60px;
  z-index: 1;
  padding: 48px 24px;
  min-width: 350px;
  margin-right: calc(25%);
`;

const HelpNavContainer = ({ children, className }) => {
  return (
    <SideNavContainer className={className}>
      <StyledSideNav className="side-nav">{children}</StyledSideNav>
    </SideNavContainer>
  );
};

export default HelpNavContainer;
